// sessionStorage can be unavailable in some cases, e.g. safari incognito mode
let storage = {};

export default {
    getItem: (key) => {
        try {
            return window.sessionStorage.getItem(key);
        } catch (err) {
            return storage[key];
        }
    },
    setItem: (key, value) => {
        try {
            window.sessionStorage.setItem(key, value);
        } catch (err) {
            storage[key] = `${value}`;
        }
    },
    removeItem: (key) => {
        try {
            window.sessionStorage.removeItem(key);
        } catch (err) {
            delete storage[key];
        }
    },
    clear: () => {
        try {
            window.sessionStorage.clear();
        } catch (err) {
            storage = {};
        }
    }
};
